<h2 class="text-2 text-light">{{ heading() }}</h2>

<p class="text-4 text-light">{{ body() }}</p>

<section>
  <a class="btn btn-tertiary" [routerLink]="link()">{{ buttonText() }}</a>
</section>
